import { PhoneOverride } from '@weave/schema-gen-ts/dist/schemas/phone/override/v2/override_service.pb';
import { Trans, useTranslation } from '@frontend/i18n';
import { useModalControl, ConfirmationModal, Text, useAlert } from '@frontend/design-system';
import { PhoneOverrideType } from './types';
import { useOverrideMutations } from './use-overrides-mutations';

interface IOverrideSettingRemoveModal {
  override: PhoneOverride | PhoneOverrideType;
  modalProps: ReturnType<typeof useModalControl>['modalProps'];
  phoneTenantId?: string;
  modalControls?: ReturnType<typeof useModalControl>;
}

export const NewOverrideSettingRemoveModal = ({
  override,
  modalProps,
  phoneTenantId,
  modalControls,
}: IOverrideSettingRemoveModal) => {
  const { t } = useTranslation('phone', { keyPrefix: 'overrides' });
  const alerts = useAlert();

  const { remove } = useOverrideMutations(phoneTenantId ?? '');

  const deleteOverrideV2 = () =>
    remove.mutate(
      { phoneOverrideId: override?.id ?? '' },
      {
        onSuccess: () => {
          alerts.success(t('Override removed successfully'));
          modalControls?.closeModal();
        },
        onError: () => {
          alerts.error(t('Override removal failed'));
        },
      }
    );

  return (
    <ConfirmationModal
      {...modalProps}
      onConfirm={() => deleteOverrideV2()}
      title={t('Remove Active Override?')}
      message={
        <Trans t={t} callRouteName={(override as PhoneOverrideType).callRouteName}>
          Removing the override will return the Call Route{' '}
          <Text as='span' weight='bold'>
            {(override as PhoneOverrideType).callRouteName}
          </Text>{' '}
          to its standard configuration.
        </Trans>
      }
      cancelLabel={t('No, Cancel')}
      confirmLabel={t('Yes, Remove')}
      destructive
      cancelTrackingId='phone-portal-button-cancelRemoveOverride'
      confirmTrackingId='phone-portal-button-removeOverride'
    />
  );
};
